module.exports = __webpack_public_path__ + "static/img/avatar-bar.c7b4901a.png";